export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12937.4706226a.jpg";